import React, { useId } from "react";

interface SettingInputFieldProps {
  label: string;
  value: string;
  placeholder: string;
  isRequired: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  type?: "text" | "number";
  helpText?: string;
  error?: string | null;
}

export const SettingInputField: React.FC<SettingInputFieldProps> = ({
  label,
  value,
  placeholder,
  isRequired,
  onChange,
  name,
  type = "text",
  helpText,
  error,
}) => {
  const id = useId();

  return (
    <div className="grid grid-cols-1 gap-2 md:grid-cols-4 md:items-start">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 md:col-span-1 pt-2">
        {label} {isRequired && <span className="text-red-500">*</span>}
      </label>
      <div className="md:col-span-3">
        <input
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full rounded-md border ${error ? 'border-red-500' : 'border-gray-300'} px-3 py-2 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm`}
        />
        {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
        {!error && helpText && <p className="mt-1 text-xs text-gray-500">{helpText}</p>}
      </div>
    </div>
  );
};